import React, { Component } from 'react';
import { Button, Upload, Icon, Popover, Input, Form } from 'antd'
import { withRouter } from 'react-router';

// Import mock util (using relative path within src)
import { apiUtil as Util, API_CONFIG } from '../../mock/mockServices';

const { Dragger } = Upload;
// const databaseName = 'auto_ml'
const trainType = 'final_train'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 19 }
  }
};

class IndexForm extends Component {
  state = {
    fileList: [],
    fileUrl: '',
    training: false
  }

  uploadConf = {
    name: 'file',
    multiple: false,
    accept: '.csv, .txt',
    showUploadList: {
      showDownloadIcon: false
    },
    // Use customRequest when in mock mode, otherwise use action
    ...(API_CONFIG.useMockData ? {
      customRequest: (options) => {
        const { onSuccess, onError } = options;

        // Simulate upload delay for mock data
        setTimeout(() => {
          if (Math.random() > 0.1) { // 90% success rate
            // Simulate successful upload response
            onSuccess({
              data: `/mock/train/files/mock_train_file_${Date.now()}.csv`,
              message: null
            });
          } else {
            onError(new Error("Upload failed"));
          }
        }, 1000);
      }
    } : {
      action: '/get/upload',
      data: {
        pathType: 'train_file'
      },
      headers: {
        token: localStorage.authToken
      }
    }),
    beforeUpload: function (file) {
      const isScvOrTxt = /^.*(\.csv|\.txt)$/.test(file.name.toLocaleLowerCase());
      if (!isScvOrTxt) {
        Util.message.error('Please upload .CSV or .TXT file');
      }
      return isScvOrTxt;
    },
    onChange: info => {
      const { status } = info.file;
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      this.setState({ fileList });
      // console.log('status change：', status)
      if (status === 'done') {
        if(info.file.response.message) {
          Util.message.error(info.file.response.message);
          this.setState({ fileList: [], trainFilePath: '' });
        } else {
          this.setState({trainFilePath: info.file.response.data})
        }
      }
      if(status === 'error' || status === 'removed') {
        info.file.error && Util.message.error(info.file.error.message);
        this.setState({ fileList: [], trainFilePath: '' });
        if (info.file.response && info.file.response.code === '401'){
          window.location.href = '/login?rederect=' + encodeURIComponent(window.location.pathname)
        }
      }
    }
  }

  normFile = e => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e.filter(f => f.status==='done' || f.status==='uploading');
    }
    return e && e.fileList.filter(f => f.status==='done' || f.status==='uploading');
  };

  // Add method to check task status
  checkTaskStatus = () => {
    // Poll every 5 seconds to check task status
    const interval = setInterval(() => {
      // Get task status
      Util.ajax.post('/train/getTrainRecord', {
        database: 'auto_ml',
        type: 'final_train',
        pageNum: 1,
        pageSize: 1
      }).then(res => {
        if (res.data && (res.data.list || []).length > 0) {
          const task = res.data.list[0];
          // If task completed successfully (status 3), trigger model list refresh and clear interval
          if (task.status === 3) {
            clearInterval(interval);
            // Dispatch custom event to notify model list refresh
            window.dispatchEvent(new Event('modelListRefresh'));
          }
          // If task failed (status 4), also clear interval
          else if (task.status === 4) {
            clearInterval(interval);
          }
        }
      }).catch(error => {
        console.error('Error checking task status:', error);
        // Clear interval on error
        clearInterval(interval);
      });
    }, 5000);
  };





  handleOk = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          training: true
        })
        const { projectName } = values
        console.log('Using Util object:', Util);
        Util.ajax.post('/train/submitTrainTask', {
          trainType,
          // trainFilePath: 'test/path/aa.txt',
          trainFilePath: this.state.trainFilePath,
          projectName
        }).then((res) => {
          Util.message.success('Submission Successful')
          // Redirect to /predict page after successful submission
          this.props.history.push('/predict');
          
          // Start polling to check task status
          this.checkTaskStatus();
        })
      }
    });
  };


  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form {...formItemLayout} onSubmit={this.handleOk}>
        <Form.Item label="Model Name">
          {getFieldDecorator('projectName', {
            rules: [{ required: true, message: 'Please enter the model name', whitespace: true }]
          })(<Input placeholder="Please enter the model name" />)}
        </Form.Item>
        <Form.Item label="Training Set Upload" required>
          {getFieldDecorator('upload', {
            valuePropName: 'uploadedFileList',
            getValueFromEvent: this.normFile,
            rules: [{ required: true, message: 'Please upload a file', type: 'array' }]
          })(
            <Dragger {...this.uploadConf} fileList={this.state.fileList}>
              <div className="bui-cols">
                <div className="ant-upload-drag-icon"><i className="iconfont">&#xe664;</i> </div>
                <div className="bui-col-1 tl">
                  <p className="ant-upload-text">Click or drag a file here</p>
                  <p className="ant-upload-hint">Support .CSV or .TXT files, with English headers </p>
                </div>
              </div>
            </Dragger>
          )}
          70% of the training set is used for training, 30% for testing
          <div className="input-tip">
            <Popover className="" overlayClassName="popover-tooltip" placement="bottom" content="See product documentation for training set format specifications" title="" trigger="hover">
              <Icon type="info-circle" />
            </Popover>
          </div>
        </Form.Item>
        {/* <Form.Item label="训练集拆分">
          <div style={{ lineHeight: 1 }}>
            <span className="fl">训练 70%</span>
            <span className="fr">测试 30%</span>
          </div>
          <Progress percent={100} successPercent={70} format={percent => `${percent} Days`} showInfo={false} />
          <div className="input-tip" style={{ top: 0 }}>
            <Popover className="" overlayClassName="popover-tooltip" placement="bottom" content="比例暂不支持修改" title="" trigger="hover">
              <Icon type="info-circle" />
            </Popover>
          </div>
        </Form.Item> */}

        <div className="ac-container">
          <Button size="large" loading={this.state.training} type="primary" htmlType="submit"> GET It </Button>
          {/* <Button type="link" onClick={() => this.props.history.push('/list')}> 查看训练记录 </Button> */}
        </div>
      </Form>
    )
  }
}

export default Form.create({ name: 'index-form' })(withRouter(IndexForm));